<div class="error">{{ error }}</div>

@if (loggingIn) {
  <loader-bar></loader-bar>
}
<div #loginInterfaceVc></div>
@if (showSignUp()) {
  <div class="sign-up" [ngClass]="{ baoying: isBaoying() }">
    <span>{{ 'noAccount' | i18n : 'sso-login' }}</span
      >&nbsp;
      <a href="#" (click)="goToEnroll($event)" data-automation="enrollLink">{{ 'signUp' | i18n : 'sso-login' }}</a>
    </div>
  }
